"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/CsvReview.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);








var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _format = require('web/screens/Broadcast/format');

var _RecipientTable = require('web/screens/Broadcast/RecipientTable');
var _helpers = require('../helpers');
var _pending = require('./pending');
var _columnStatus = require('./columnStatus');

/* The FileView page size (the server allows up to 50). */
 const ROWS_PAGE = 50; exports.ROWS_PAGE = ROWS_PAGE



/* What the review shows: the file as one source (index 0, so FileView can
 * page it). */
 const reviewRequest = (campaign, p) => ({
  CampaignKey: campaign.CampaignKey,
  Sources: _pending.toSources.call(void 0, { ...p, rows: [] }, _pending.declaredVariables.call(void 0, p, campaign.TemplateFields.map(f => f.Name))),
}); exports.reviewRequest = reviewRequest









/* One page of the review: every row, or the rows that need attention (the
 * server pages rows that can't be added and rows missing a value apart, so
 * this reads the first, then the second). */
const loadPage = async (request, view, offset) => {
  const page = (Filter, Offset, Limit = exports.ROWS_PAGE) =>
    _actions2.default.previewCampaignRecipients({ ...request, FileView: { SourceIndex: 0, Offset, Limit, Filter } })
  if (view === 'all') {
    const preview = await page('all', offset)
    return { request, view, offset, preview, rows: _nullishCoalesce(_optionalChain([preview, 'access', _ => _.FileView, 'optionalAccess', _2 => _2.Rows]), () => ( [])) }
  }
  const preview = await page('errors', offset)
  const errors = preview.FileView
  const rows = [..._nullishCoalesce(_optionalChain([errors, 'optionalAccess', _3 => _3.Rows]), () => ( []))]
  if (rows.length < exports.ROWS_PAGE) {
    const missing = await page('missing', Math.max(0, offset - (_nullishCoalesce(_optionalChain([errors, 'optionalAccess', _4 => _4.Total]), () => ( 0)))), exports.ROWS_PAGE - rows.length)
    rows.push(..._nullishCoalesce(_optionalChain([missing, 'access', _5 => _5.FileView, 'optionalAccess', _6 => _6.Rows]), () => ( [])))
  }
  return { request, view, offset, preview, rows }
}

/* Loads the review for the current request (none while p is null); null
 * until the first answer. */
 const useReview = (campaign, p, view, offset) => {
  const request = _react.useMemo.call(void 0, () => p && exports.reviewRequest.call(void 0, campaign, p), [campaign, p])
  const [loaded, setLoaded] = _react.useState(null)
  const [error, setError] = _react.useState(null)
  _react.useEffect.call(void 0, 
    () => {
      if (!request) return
      let isCurrent = true
      setError(null)
      loadPage(request, view, offset)
        .then(next => { if (isCurrent) setLoaded(next) })
        .catch((e) => { if (isCurrent) setError(_helpers.errorText.call(void 0, e, "Couldn't check the rows")) })
      return () => { isCurrent = false }
    },
    [request, view, offset],
  )
  const isCurrent = !!loaded && loaded.request === request && loaded.view === view && loaded.offset === offset
  return { loaded, isCurrent, error }
}; exports.useReview = useReview









const statusOf = (match, missing, error, updated) => {
  if (match === 'error') {
    const reason = _columnStatus.rowErrorReason.call(void 0, _nullishCoalesce(error, () => ( '')))
    const isContact = reason.field === 'phone' || /phone or email/i.test(_nullishCoalesce(error, () => ( '')))
    return { tone: 'error', label: isContact ? 'Invalid phone' : "Can't add", reason: reason.text }
  }
  // Rev 32 V5: someone already in the campaign; the file's new values replace theirs.
  if (match === 'already_in_campaign') {
    return _optionalChain([updated, 'optionalAccess', _7 => _7.length])
      ? { tone: 'new', label: 'Updates values', reason: `New ${updated.join(', ')}` }
      : { tone: 'quiet', label: 'Already added' }
  }
  if (match === 'duplicate') return { tone: 'quiet', label: 'Counted once' }
  if (missing.length) return { tone: 'missing', label: 'Missing value', reason: `No ${missing.join(', ')}` }
  if (match === 'new') return { tone: 'new', label: 'New patient' }
  return { tone: 'ready', label: 'Ready' }
}

/* A file row as the review shows it. */











const nameOf = (p) => [p.FirstName, p.LastName].filter(Boolean).join(' ')

const reviewRow = (row) => {
  // Rev 32 V5: someone already in the campaign keeps their own value where
  // the file is blank, so a blank isn't missing for them.
  const missing = row.Match === 'already_in_campaign' ? [] : row.Missing
  return {
    key: `file-${row.Row}`,
    name: nameOf(row) || row.Phone || row.Email || `Row ${row.Row}`,
    contact: row.Phone || row.Email,
    values: row.Values,
    missing,
    status: statusOf(row.Match, missing, row.Error, row.UpdatedValues),
    row: row.Row,
  }
}
















/* Rev 31 v2 · 4b: the file's rows before the Add. A row can be removed from
 * this import (Rev 34 S1: rows aren't edited here; fix the file, Skip, or set
 * a default in Edit message). */
const CsvReview = ({
  fileName, pending, onChange, view, onView, offset, onOffset, loaded, isCurrent, isAdding, onDownloadErrors,
}) => {
  const [file] = pending.files
  const variables = _react.useMemo.call(void 0, 
    () => _nullishCoalesce(_optionalChain([file, 'optionalAccess', _8 => _8.mapping, 'access', _9 => _9.flatMap, 'call', _10 => _10(m => m.Destination === 'variable' ? [m.Variable] : [])]), () => ( [])),
    [file],
  )

  const preview = _optionalChain([loaded, 'optionalAccess', _11 => _11.preview])
  const rows = (_nullishCoalesce(_optionalChain([loaded, 'optionalAccess', _12 => _12.rows]), () => ( [])))
    // A row just removed leaves at once, before the re-check.
    .filter(r => r.Match !== 'excluded' && !_optionalChain([file, 'optionalAccess', _13 => _13.excludedRows, 'access', _14 => _14.includes, 'call', _15 => _15(r.Row)]))
    .map(reviewRow)

  const summary = _optionalChain([preview, 'optionalAccess', _16 => _16.Sources, 'access', _17 => _17[0], 'optionalAccess', _18 => _18.Kind]) === 'file' ? preview.Sources[0] : null
  const allCount = summary ? summary.FilterCounts.all - summary.ExcludedRows : 0
  const attentionCount = summary ? summary.FilterCounts.errors + summary.FilterCounts.missing : 0
  const pageTotal = view === 'all' ? (summary ? summary.FilterCounts.all : 0) : attentionCount

  const remove = (r) => {
    if (!file) return
    onChange(p => _pending.updateFile.call(void 0, p, file.id, f => f.excludedRows.includes(r.row) ? f : { ...f, excludedRows: [...f.excludedRows, r.row] }))
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "broadcast-csv-review--bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}
        , _react2.default.createElement('div', { className: "broadcast-csv-review--switch", role: "group", 'aria-label': "Show rows" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}
          ,  ([['all', 'All rows', allCount], ['attention', 'Needs attention', attentionCount]] )
            .map(([v, label, n]) => (
              _react2.default.createElement('button', {
                key: v,
                type: "button",
                'aria-pressed': view === v,
                className: _classBuilder2.default.call(void 0, 'broadcast-csv-review--switch-option', view === v && 'broadcast-csv-review--switch-option--on'),
                onClick: () => onView(v), __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}

                ,  label , " · "  ,  _format.formatCount.call(void 0, n) 
              )
            ))
        )
        , _react2.default.createElement('span', { className: "broadcast-csv-review--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}} )
        ,  onDownloadErrors && (_nullishCoalesce(_optionalChain([summary, 'optionalAccess', _19 => _19.FilterCounts, 'access', _20 => _20.errors]), () => ( 0))) > 0 && (
          _react2.default.createElement('button', { type: "button", className: "broadcast-mapping--link", onClick: onDownloadErrors, __self: this, __source: {fileName: _jsxFileName, lineNumber: 198}}, "Download rows that can't be added"

          )
        )
        , _react2.default.createElement('span', { className: "broadcast-csv-review--file", __self: this, __source: {fileName: _jsxFileName, lineNumber: 202}},  fileName )
      )
      , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'broadcast-csv-review--scroll', !isCurrent && 'broadcast-csv-review--stale'), 'aria-busy': !isCurrent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}}
        , _react2.default.createElement('table', { className: "broadcast-csv-review", 'aria-label': "Rows to add"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}
          , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}
            , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 207}}
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}, "Patient")
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}, "Contact")
              ,  variables.map(v => _react2.default.createElement('th', { key: v, scope: "col", className: "broadcast-csv-review--var", __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}},  v )) 
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}, "Status")
              , _react2.default.createElement('th', { scope: "col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}, _react2.default.createElement('span', { className: "broadcast-visually-hidden", __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}, "Actions"))
            )
          )
          , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}
            ,  loaded && rows.length === 0 && (
              _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}, _react2.default.createElement('td', { colSpan: variables.length + 4, className: "broadcast-csv-review--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}, "No rows here."  ))
            )
            ,  rows.map(r => (
              _react2.default.createElement('tr', { key: r.key, __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}
                , _react2.default.createElement('th', { scope: "row", className: "broadcast-csv-review--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}},  r.name )
                , _react2.default.createElement('td', { className: _classBuilder2.default.call(void 0, 'broadcast-csv-review--contact', r.status.tone === 'error' && 'broadcast-csv-review--bad'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 222}},  r.contact )
                ,  variables.map(v => (
                  _react2.default.createElement('td', { key: v, className: "broadcast-csv-review--var", __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}
                    ,  _optionalChain([r, 'access', _21 => _21.values, 'access', _22 => _22[v], 'optionalAccess', _23 => _23.trim, 'call', _24 => _24()])
                      ? r.values[v]
                      : r.missing.includes(v)
                        ? _react2.default.createElement('span', { className: "broadcast-csv-review--missing", __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}, "Missing")
                        : null
                    
                  )
                ))
                , _react2.default.createElement('td', { className: "broadcast-csv-review--status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 233}}
                  , _react2.default.createElement('span', {
                    className: `campaign--table--status-pill broadcast-csv-review--pill broadcast-csv-review--pill-${r.status.tone}`,
                    title: r.status.reason, __self: this, __source: {fileName: _jsxFileName, lineNumber: 234}}

                    , _react2.default.createElement('span', { className: "campaign--table--status-pill--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}},  r.status.label )
                  )
                )
                , _react2.default.createElement('td', { className: "broadcast-csv-review--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}}
                  , _react2.default.createElement('button', {
                    type: "button",
                    className: "broadcast-csv-review--icon",
                    'aria-label': `Remove ${r.name}`,
                    disabled: isAdding,
                    onClick: () => remove(r), __self: this, __source: {fileName: _jsxFileName, lineNumber: 242}}
, "🗑"

                  )
                )
              )
            ))
          )
        )
      )
      , _react2.default.createElement(_RecipientTable.RecipientPager, {
        page: Math.floor(offset / exports.ROWS_PAGE),
        pageCount: Math.ceil(pageTotal / exports.ROWS_PAGE),
        onPage: page => onOffset(page * exports.ROWS_PAGE),
        className: "broadcast-csv-review--pager", __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
      )
    )
  )
}

exports. default = CsvReview
